import { SingleUserFieldFilter } from 'module/types/filter-field/filter/single-user';
import { FC, useMemo } from 'react';
import { SingleSelectBaseFilterToText } from './single-select-base-filter';
import { UserOptionsGetter } from '../types';

export const SingleUserFilterToText: FC<{
  filter: SingleUserFieldFilter;
  optionsGetter?: UserOptionsGetter;
}> = ({ filter, optionsGetter }) => {
  const options = useMemo(
    () =>
      optionsGetter != null
        ? optionsGetter(filter.field)
        : (filter.field.metaData.options ?? []),
    [filter.field, optionsGetter],
  );

  return <SingleSelectBaseFilterToText filter={filter} options={options} />;
};
